import React from "react";
import { PickupCargoInternodeRoutePackagesDataInterface } from "../../../../redux/interfaces/raports.interface";
import { getDateAndTime } from "../../../../utils/dateAndTime";

import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import { useAppDispatch } from "../../../../redux/hooks";
import {
  openClosePackageCargoInternodeRouteModal,
  setSelectedCargoInternodeItemForClosing,
} from "../../../../redux/reducer/raports.reducer";

function PackagesTable({
  packages,
}: {
  packages: PickupCargoInternodeRoutePackagesDataInterface[];
}) {
  const dispatch = useAppDispatch();

  const packageStatusesValues = [
    { value: 0, label: "Colet creat" },
    { value: 1, label: "Colet preluat" },
    { value: 2, label: "Colet intrat in nod" },
    { value: 3, label: "Colet posibil in bin" },
    { value: 4, label: "Colet scos din bin" },
    { value: 10, label: "Colet livrat" },
    { value: 20, label: "Colet nelivrat" },
    { value: 21, label: "Colet intrat in nod pentru retur" },
    { value: 22, label: "Colet iesit din nod pt retur" },
    { value: 23, label: "Colet reintors la expeditor" },
    { value: 30, label: "Colet anulat" },
    { value: 40, label: "Colet preluat individual pe internod" },
  ];

  const packagingTypesValues = [
    { value: 78, label: "Plic" },
    { value: 72, label: "Colet " },
    { value: 73, label: "Cutie plastic" },
    { value: 74, label: "Palet" },
    { value: 75, label: "Colet frig" },
    { value: 77, label: "Ridicare numerar" },
    { value: 79, label: "Palet 1/2" },
  ];

  const getStatusLabelForPackage = (status: number) => {
    const getStatus = packageStatusesValues.find((s) => s.value === status);

    return getStatus?.label;
  };

  const getLabelForPackagingType = (status: number) => {
    const getStatus = packagingTypesValues.find((s) => s.value === status);

    return getStatus?.label;
  };

  return (
    <div className="overflow-x-auto">
      <h2 className="mb-5 text-xl font-bold text-gray-900">Colete</h2>

      <table className="mb-0 w-full border-collapse text-left text-sm font-semibold text-gray-900 [&_tbody]:divide-y [&_tbody]:divide-slate-200 [&_td]:px-4 [&_td]:py-4 [&_th]:px-4 [&_th]:py-3">
        <thead className="bg-surface-subtle text-muted">
          <tr>
            <th>Nr. expeditie</th>
            <th>Client</th>
            <th>Punct preluare</th>
            <th>Punct livrare</th>
            <th>Adresa</th>
            <th>Nod dest.</th>
            <th>Ruta</th>
            <th>Status</th>
            <th>Ambalaj</th>
            <th>Data crearii</th>
            <th className="text-right">Actiuni</th>
          </tr>
        </thead>
        <tbody>
          {packages.map((c) => {
            const handleClosePackage = () => {
              dispatch(
                setSelectedCargoInternodeItemForClosing({
                  id: c.id_doctrans_detl,
                  type: "COLET",
                  label: c.doc_trans,
                }),
              );
              dispatch(openClosePackageCargoInternodeRouteModal());
            };

            return (
              <tr
                key={c.id_doctrans_detl}
                className="transition-colors hover:bg-surface-subtle/70">
                <td>{c.doc_trans}</td>
                <td>{c.client}</td>
                <td>{c.punct_preluare}</td>
                <td>{c.punct_livrare}</td>
                <td>{c.adresa}</td>
                <td>{c.nod_destinatie}</td>
                <td>{c.ruta}</td>
                <td>
                  <span className="inline-flex rounded-control bg-info-subtle px-3 py-2 text-info">
                    {getStatusLabelForPackage(c.status)}
                  </span>
                </td>
                <td>
                  <span className="inline-flex rounded-control bg-info-subtle px-3 py-2 text-info">
                    {getLabelForPackagingType(c.tip_ambalaj)}
                  </span>
                </td>
                <td>
                  <span className="inline-flex rounded-control bg-info-subtle px-3 py-2 text-info">
                    {getDateAndTime(c.data_creare)}
                  </span>
                </td>
                <td className="text-right">
                  <ActionMenu
                    title={c.doc_trans}
                    minItemsForMenu={2}
                    items={[
                      {
                        id: "close-package",
                        label: "Inchide coletul",
                        icon: "CLOSE_ICON",
                        color: "error",
                        tooltip:
                          "Deschide formularul pentru inchiderea acestui colet.",
                        onClick: handleClosePackage,
                      },
                    ]}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default PackagesTable;
